<template>
  <div>
    <List
      url="device_alarm_channels/"
      :title="title"
      titleClass="title"
      :data="searchData"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealList"
      :operat="operat"
    >
      <div slot="Filter" style="display: flex;line-height:30px; ">
        <label>云平台：</label>
        <el-checkbox-group style="margin-right:30px" v-model="platform">
          <el-checkbox
            v-for="platform in platforms"
            :label="platform"
            :key="platform"
            :value="platform"
          ></el-checkbox>
        </el-checkbox-group>
        <el-button @click="search" type="primary" size="small">搜索</el-button>
      </div>
    </List>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import { Channelstatus } from "../components/Index/data.js";
export default {
  components: {
    List
  },
  data() {
    return {
      tanle: [
        { name: "close_time", label: "关闭时间" },
        { name: "mac", label: "MAC地址" },
        { name: "cloud", label: "云平台", type: 1 },
        { name: "is_closeName", label: "状态" }
      ],
      searchData: {
        cloud: ""
      },
      platform: [],
      operat: [],
      updateList: 0,
      platforms: ["ucloud", "ecloud", "scloud", "sacloud", "t-healthcare", "test_kyy", "dev_sh", "dev_hz", "jcloud", "ccloud", "aucloud", "azcloud", "rucloud", "discreet", "discreet2025", "ecloud-tis", "dev", "test", "test84", "test_hz", "test_hager"],
      title: "已关闭告警通道的设备列表"
    };
  },
  mounted() {},
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].close_time = this.changeDate(data[i].close_time);
        data[i].is_closeName = Channelstatus[data[i].is_close];
      }
      return data;
    },
    search() {
      this.searchData.cloud = this.platform.join(",");
      this.updateList++;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>
